import { jsx, jsxs } from 'react/jsx-runtime';
import cns from '../../../node_modules/classnames/index.js';
import Button from '../Button/Button.js';
import CloseIcon from '../../GoogleIcons/Outlined/CloseIcon.js';
import useFloatingUiTrialContext from '../../FloatingUiTrial/useFloatingUiTrialContext.js';
import { Emphasis } from '../../types.js';

/**
 * Componente che renderizza il contenuto del popup di un `Tooltip`.
 */
function TooltipContent({ onClose = undefined, children, className = undefined }) {
    const { floatingUiActive } = useFloatingUiTrialContext();
    return (jsx("div", { className: cns('v2-tooltip__content-wrapper', { 'floating-ui': floatingUiActive }), children: jsxs("div", { className: cns('v2-tooltip__content', className), children: [children, onClose
                    && (jsx(Button, { className: "v2-tooltip__close-button", onClick: onClose, emphasis: Emphasis.LOW, children: jsx(CloseIcon, {}) }))] }) }));
}

export { TooltipContent as default };
